import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C({ tags }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('loadshedding');
    return (
        <div id="load-shedding-C" className={`load-shedding-C ${css['load-shedding-C']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <h2 className="title">{t('secC_title')}</h2>
                </div>
                <div className="tags">
                    {tags?.map((tag: any, k: number) => (
                        <a className="tag" href={tag?.link} key={k}>
                            {tag?.text}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
